import styled from 'styled-components'
export const NotificationContainer = styled.div`
  width: 100%;
  margin: auto;
`

export const NotificationItem = styled.li`
  background-color: 'white';
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 10px;
  &.isRead {
    background-color: '#FFEDCA';
  }
  padding: 21px 16px;
`

export const CustomButton = styled.button`
  width: 98px;
  border-radius: 5px;
  background-color: black;
  color: white;
  cursor: pointer;
`

export const DateWrapper = styled.div`
  background-color: #f5f8fb;
  padding: 21px 16px;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 10px;
`
